module.exports = __webpack_public_path__ + "static/paris-010-5eb2055d4f9d9531139763ca21a0d3c6.jpg";